class PopupViewer {
  constructor() {
    this.visible = false;
    this.image = null;
    this.images = [];
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchEndX = 0;
    this.touchEndY = 0;
    this.current = 0;
    this.total = 0;

    this.init();
  }

  init() {
    this.createHTML();
    this.bindEvents();
    document.addEventListener("click", this.handleClick.bind(this));
  }

  createHTML() {
    // Create popup HTML
    const popupHTML = `
      <div class="popup" id="image-popup">
        <div class="popup-container">
          <img class="popup-image" id="popup-image" />
          <video class="popup-image" id="popup-video" controls>
            <source id="popup-video-source" src="" type="">
          </video>
        </div>
        <div id="popup-image-prev" class="icon">navigate_before</div>
        <div id="popup-image-next" class="icon">navigate_next</div>
        <div id="popup-image-count"></div>
        <div id="popup-image-close" class="icon">close</div>
        <a id="popup-image-open" class="icon" target="_blank">open_in_new</a>
      </div>
    `;

    // Create CSS
    const style = document.createElement("style");
    style.textContent = `
      ::root {
        --transparency: url(data:image/webp;base64,UklGRiYAAABXRUJQVlA4TBkAAAAvD8ADAAWRto2Te5h/fYXnEf2fgDj+cfwDAA==);
      }
    
      [popupable] {
        cursor: pointer;
      }

      .popup {
        position: fixed;
        inset: 0;
        background-color: rgba(255, 255, 255, 0.75);
        z-index: 9999999999;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0;
        transition: opacity .2s;
        pointer-events: none;
        backdrop-filter: blur(4px);
      }

      .popup-container {
        position: relative;
        user-select: none;
        box-shadow: 0 8px 16px rgba(0,0,0,0.5);
        max-width: calc(100vw - 92px * 2);
        max-height: calc(100dvh - 92px * 2);
        overflow: hidden;
        scale: .85;
        transition: scale .15s ease;
      }

      .popup-visible {
        opacity: 1;
        pointer-events: initial;
        touch-action: none;
      }

      .popup-visible .popup-container {
        scale: 1;
      }

      .popup-image {
        max-width: calc(100vw - 92px * 2);
        max-height: calc(100dvh - 92px * 2);
        display: block;
        background-image: var(--transparency);
        image-rendering: pixelated;
        object-fit: contain;
      }

      #popup-image-count {
        position: absolute;
        top: 46px;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
      }

      .popup .icon {
        color: #fff;
        position: absolute;
        cursor: pointer;
        width: 60px;
        height: 60px;
        font-size: 40px;
        background-color: rgba(0,0,0,0.4);
        transition: background-color .15s ease, box-shadow .15s ease;
        user-select: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Material Symbols Outlined', sans-serif;
        text-decoration: none;
        border-radius: 50%;
      }

      .popup .icon:hover {
        background: rgba(0,0,0,0.7);
        box-shadow: var(--box-shadow, 0 4px 8px rgba(0,0,0,0.2));
      }

      .popup .icon.inactive {
        background-color: rgba(0,0,0,0.4);
        box-shadow: initial;
        opacity: .25;
        cursor: not-allowed;
      }

      #popup-image-close, #popup-image-open {
        top: 16px;
        right: 16px;
      }

      #popup-image-open {
        right: 92px;
        font-size: 32px;
      }

      #popup-image-prev {
        left: 16px;
        font-size: 48px;
      }

      #popup-image-next {
        right: 16px;
        font-size: 48px;
      }

      @media (max-width: 768px) {
        .popup-container {
          max-width: calc(100vw - 14px * 2);
          max-height: calc(100dvh - 56px * 2);
        }

        .popup-image {
          max-width: calc(100vw - 14px * 2);
          max-height: calc(100dvh - 56px * 2);
        }

        #popup-image-count {
          top: 28px;
          font-size: 16px;
        }

        .popup .icon {
          width: 40px;
          height: 40px;
          font-size: 24px;
        }

        #popup-image-close, #popup-image-open {
          top: 8px;
          right: 8px;
        }

        #popup-image-open {
          right: 56px;
          font-size: 22px;
        }

        #popup-image-prev {
          left: 50%;
          transform: translateX(calc(-100% - 4px));
          font-size: 32px;
          bottom: 8px;
        }

        #popup-image-next {
          left: calc(50% + 4px);
          right: initial;
          font-size: 32px;
          bottom: 8px;
        }
      }
    `;

    // Add styles to head
    document.head.appendChild(style);

    // Add popup HTML to body
    document.body.insertAdjacentHTML("beforeend", popupHTML);

    // Get element references
    this.popup = document.getElementById("image-popup");
    this.popupImage = document.getElementById("popup-image");
    this.popupVideo = document.getElementById("popup-video");
    this.popupVideoSource = document.getElementById("popup-video-source");
    this.prevBtn = document.getElementById("popup-image-prev");
    this.nextBtn = document.getElementById("popup-image-next");
    this.countEl = document.getElementById("popup-image-count");
    this.closeBtn = document.getElementById("popup-image-close");
    this.openBtn = document.getElementById("popup-image-open");
  }

  bindEvents() {
    this.popup.addEventListener("click", this.closePopup.bind(this));
    this.popup.addEventListener("touchstart", this.handleTouchStart.bind(this));
    this.popup.addEventListener("touchend", this.handleTouchEnd.bind(this));

    this.prevBtn.addEventListener("click", this.prevImage.bind(this));
    this.nextBtn.addEventListener("click", this.nextImage.bind(this));
    this.closeBtn.addEventListener("click", this.closePopup.bind(this));
  }

  handleClick(e) {
    let element = e.target;
    while (element && !element.hasAttribute("popupable")) {
      if (["BUTTON", "A"].includes(element.tagName)) return;
      element = element.parentElement;
    }
    if (!element) return;

    const value = element.getAttribute("popupable");
    this.images = Array.from(
      document.querySelectorAll(`[popupable="${value}"]`)
    ).filter((el) => {
      if (el.closest('[id*="clone"]')) return false;
      let node = el;
      while (node && node !== document.body) {
        const style = getComputedStyle(node);
        if (style.display === "none" || style.visibility === "hidden")
          return false;
        node = node.parentElement;
      }
      return true;
    });

    if (this.images.length === 1) {
      this.prevBtn.hidden = true;
      this.nextBtn.hidden = true;
      this.countEl.hidden = true;
    } else {
      this.prevBtn.hidden = false;
      this.nextBtn.hidden = false;
      this.countEl.hidden = false;
      this.total = this.images.length;
    }

    this.loadImage(element);
    this.visible = true;
    this.popup.classList.add("popup-visible");
  }

  loadImage(img) {
    this.image = img;
    const index = this.images.indexOf(img);
    this.current = index + 1;

    const src = img.getAttribute("popup-src") || img.getAttribute("src");

    if (img.getAttribute("popup-type") === "video") {
      this.popupImage.hidden = true;
      this.popupVideo.hidden = false;
      this.popupVideoSource.src = src;
      try {
        const url = new URL(src, window.location.href);
        const extension = url.pathname.split(".").pop().toLowerCase();
        const mimeTypes = {
          mp4: "video/mp4",
          webm: "video/webm",
          ogg: "video/ogg",
          mov: "video/quicktime",
          avi: "video/x-msvideo",
        };
        this.popupVideoSource.type = mimeTypes[extension] || "video/mp4";
      } catch {
        this.popupVideoSource.type = "video/mp4";
      }
      this.popupVideo.load();
      this.popupVideo.play();
    } else {
      this.popupVideo.hidden = true;
      this.popupImage.hidden = false;
      this.popupImage.src = src;
    }

    this.openBtn.href = src;

    if (index) {
      this.prevBtn.classList.remove("inactive");
    } else {
      this.prevBtn.classList.add("inactive");
    }

    if (index === this.images.length - 1) {
      this.nextBtn.classList.add("inactive");
    } else {
      this.nextBtn.classList.remove("inactive");
    }

    this.countEl.textContent = `${this.current} / ${this.total}`;
  }

  closePopup(e) {
    if (e.target === e.currentTarget || e.target === this.closeBtn) {
      this.visible = false;
      this.popup.classList.remove("popup-visible");
      this.popupVideo.pause();
    }
  }

  nextImage() {
    if (!this.nextBtn.classList.contains("inactive")) {
      this.loadImage(this.images[this.images.indexOf(this.image) + 1]);
    }
  }

  prevImage() {
    if (!this.prevBtn.classList.contains("inactive")) {
      this.loadImage(this.images[this.images.indexOf(this.image) - 1]);
    }
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].screenX;
    this.touchStartY = e.touches[0].screenY;
  }

  handleTouchEnd(e) {
    const endX = e.changedTouches[0].screenX;
    const endY = e.changedTouches[0].screenY;
    const deltaX = endX - this.touchStartX;
    const deltaY = endY - this.touchStartY;

    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      if (Math.abs(deltaX) < 50) return;
      const index = this.images.indexOf(this.image);
      if (deltaX > 0 && index > 0) {
        this.prevImage();
      } else if (deltaX < 0 && index < this.images.length - 1) {
        this.nextImage();
      }
    } else {
      if (Math.abs(deltaY) < 50) return;
      const index = this.images.indexOf(this.image);
      if (deltaY > 0 && index > 0) {
        this.prevImage();
      } else if (deltaY < 0 && index < this.images.length - 1) {
        this.nextImage();
      }
    }
  }
}

// Initialize the popup viewer when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  window.popupViewer = new PopupViewer();
});
